import React from 'react';
import HomeScreen from "../homescreen/homescreen";

class MyProjects extends HomeScreen {

    constructor(props) {
        props = {
            screenName: 'Projects',
            ...props
        };
        super(props);
    }

    renderHomeContent() {
        return (
            <div>

                <div className='sectionInnerTitle'><span>06/01/2025 -  </span><b>Game Map Editor</b></div>

                <p className='sectionDescription'>I've created a map editor for the game I shared further in this section. It can found <a href='https://mapeditor.condemakoto.com/'><b>here</b></a></p>.
                <a href='https://mapeditor.condemakoto.com/'><img src={'/assets/editor_screenie.png'} style={{width: '290px', marginTop: '12px'}}/></a>
                <p className='sectionDescription'>The editor for now is pretty basic, and it doesn't have that many assets yet, but it's helpful enough for me to design the new scenarios for my game.'</p>
                <br/>

                <div className='sectionInnerTitle'><span>13/12/2024 -  </span><b>Sakana</b></div>

                <div style={{display: "flex"}}>
                    <span>
                            <a href='https://sakana.com.ar'>
                                <img width='100px' src='/assets/sakana_logo_small.png'></img>
                            </a>
                    </span>
                    <span style={{marginLeft: "12px"}}>
                        <p className='sectionDescription'><b>Sakana</b> is an echo sounder simulator, which is basically the "sound radars" that are normally being used on ships.</p>
                        <br></br>
                        <p className='sectionDescription'>While it started as graduation project, it later turned out to a part time job, funded partially by the <b>Argentinian</b> government through the <b>FONSOFT</b> program. Sadly, things don't work in Argentina very well, and long-story short, the funds were cut. </p>
                    </span>
                </div>
                <br/>
                <p className='sectionDescription'>I'm still hosting the website for the project, and it can be found <a href="https://sakana.com.ar/">here</a>. There is still a demo that's available for download.</p>
                <br/>


                <div className='sectionInnerTitle'><span>04/11/2024 -  </span><b>HTML 5 game    </b></div>

                <a href='https://test.condemakoto.com'>
                     <img width='300px' src='/assets/game_v1.png'></img>
                </a>
                <br/>
                <br/>
                <p className='sectionDescription'>I just uploaded the very first version of a HTML 5 game I started a couple of years ago.
                For now it's pretty simple, you can just walk around an empty space by clicking on the tiles.
                It allows also to move the camera around with the arrows, and zooming in/out with the +/- keys.</p>
                <p className='sectionDescription'>I've been refactoring this project to so it can be used as a multiplayer game, and will soon be available here.</p>
            </div>
        );
    }

    getScreenName() {
        return 'Projects';
    }
}

export default MyProjects;


// WEBPACK FOOTER //
// ./src/screens/projects/index.js